import { render, staticRenderFns } from "./ThanksForm.vue?vue&type=template&id=9dd8233e&scoped=true&"
import script from "./ThanksForm.vue?vue&type=script&lang=ts&"
export * from "./ThanksForm.vue?vue&type=script&lang=ts&"
import style0 from "./ThanksForm.vue?vue&type=style&index=0&id=9dd8233e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9dd8233e",
  null
  
)

export default component.exports